export default __webpack_public_path__ + "static/floating-dark-e50b983661edc17c3e937090a4ef71c0.png";